var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { ADDITIONAL_FIELD_TYPES } from '../../config';
import { Col, CustomInput } from 'reactstrap';
import DishHelper from './DishHelper';
import ChangeAmount from '../common/ChangeAmount';
var changeAmountValueStyle = { width: 25, textAlign: 'center' };
var DishAdditionalField = function (_a) {
    var field = _a.field, fieldValue = _a.fieldValue, changeFieldValue = _a.changeFieldValue;
    if (field.type === ADDITIONAL_FIELD_TYPES.MULTIPLE_CHOICE) {
        var setOptionAmount_1 = function (key, amount) {
            var _a;
            var newValue = __assign(__assign({}, fieldValue), (_a = {}, _a[key] = amount, _a));
            changeFieldValue(field, newValue);
        };
        // @ts-ignore fix this later when fieldValues in DishModal will be typed
        var optionalsAmount_1 = Object.values(fieldValue).reduce(function (acc, item) { return (acc + item); }, 0);
        return React.createElement("div", { className: "dish__additional-field" },
            React.createElement("strong", null,
                "Wybierz ",
                field.name,
                " ",
                field.max > 1 ? "(maks. ".concat(field.max, ")") : ''),
            DishHelper.getFieldOptions(field).map(function (opt) {
                var name = opt;
                var optionAmount = fieldValue[name] || 0;
                return React.createElement(React.Fragment, { key: name },
                    React.createElement("div", { className: "row align-items-center mt-2", key: name },
                        React.createElement(Col, null, name),
                        React.createElement(ChangeAmount, { disableDecrease: optionAmount < 1, disableIncrease: optionalsAmount_1 >= field.max, onUpdateValue: function (newAmount) { return setOptionAmount_1(name, newAmount); }, small: true, value: optionAmount, valueStyle: changeAmountValueStyle, wrapperClass: "row col align-items-center" })));
            }));
    }
    if (field.type === ADDITIONAL_FIELD_TYPES.SINGLE_CHOICE) {
        var options = DishHelper.getFieldOptions(field);
        return React.createElement("div", { key: field.name, className: "dish__additional-field dish__options" },
            React.createElement("strong", { className: "dish-modal__field-title" },
                "Wybierz ",
                field.name),
            React.createElement("select", { className: "form-control", onChange: function (e) { return changeFieldValue(field, e.target.value); }, value: fieldValue || options[0] }, options.map(function (opt) { return React.createElement("option", { key: opt, value: opt }, opt); })));
    }
    if (field.type === ADDITIONAL_FIELD_TYPES.CHECKBOX) {
        return React.createElement(CustomInput, { className: "mt-2", type: "checkbox", key: field.name, id: field.name, label: React.createElement("span", null,
                field.name,
                DishHelper.formatAddonPrice(field)), onChange: function (e) { return changeFieldValue(field, e.target.checked); }, checked: fieldValue });
    }
    return null;
};
export default DishAdditionalField;
